var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"result-item post",on:{"click":_vm.goToPost}},[_c('v-image',{attrs:{"default":'DefaultCommunityVisual.png',"image-id":_vm.post.idImage}}),_c('div',{staticClass:"item-info"},[_c('post-search',{attrs:{"post":_vm.post}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }